import React from 'react'
import { MarqueeWrapper } from './style'

interface Props {
  children?: React.ReactNode
}

/**
 * Componente Marquee
 *
 * O componente Marquee é um componente reutilizável que cria um efeito de marquee.
 * Ele recebe elementos filhos e os duplica para criar um efeito de rolagem contínua.
 *
 * Props:
 * - children (React.ReactNode): Os elementos a serem exibidos no marquee. Esses elementos serão duplicados para criar o efeito de rolagem.
 *
 * Exemplo de uso:
 * ```jsx
 * <Marquee>
 *   <img src="http://example.com" />
 *   <img src="http://example.com" />
 *   <img src="http://example.com" />
 * </Marquee>
 * ```
 */
const Marquee = ({ children }: Props) => {
  return (
    <MarqueeWrapper>
      <div className="marquee-group">{children}</div>
      <div className="marquee-group">{children}</div>
    </MarqueeWrapper>
  )
}

export default Marquee
